import { Table, Typography, type TableProps } from 'antd'
import dayjs from 'dayjs'
import { useMemo } from 'react'

import type { BillableAction } from '../../../../../types'

type BillableActionTableProps = {
    billableActions: BillableAction[]
    name: 'EN' | 'NZ'
}

const labelMapping = {
    NZ: 'New Zealand',
    EN: 'England'
}

export const BillableActionsTable = ({ name, billableActions }: BillableActionTableProps) => {
    const totals = useMemo(
        () =>
            billableActions.reduce(
                (collector, ba) => {
                    return {
                        units: collector.units + ba.units,
                        cost: collector.cost + ba.units * ba.costPerUnit
                    }
                },
                {
                    units: 0,
                    cost: 0
                }
            ),
        [billableActions]
    )

    const columns: TableProps<BillableAction>['columns'] = [
        {
            title: 'units',
            dataIndex: 'units'
        },
        {
            title: 'Action',
            dataIndex: 'action'
        },
        {
            title: 'Cost Per Unit',
            dataIndex: 'costPerUnit'
        },
        {
            title: 'Product',
            dataIndex: 'item'
        },
        {
            title: 'Currency',
            dataIndex: 'currency'
        },
        {
            title: 'Created At',
            key: 'createdAt',
            render: (_, { createdAt }) => <>{dayjs(createdAt).fromNow()}</>
        },
        {
            title: 'isBilled',
            key: 'isBilled',
            render: (_, { isBilled }) => <>{isBilled ? <>Yes</> : <>No</>}</>
        }
    ]

    return (
        <>
            <Typography.Title level={3}>{labelMapping[name]}</Typography.Title>

            <Typography.Text>
                Total: £{totals.cost} for {totals.units} units
            </Typography.Text>
            <Table columns={columns} dataSource={billableActions || []} rowKey="id" pagination={false} />
        </>
    )
}
